import {Dto} from "common";

export abstract class ActivityResultsModel extends Dto {
    abstract deserialize(input: any): this;
}
